<template>
  <div class="case-actions" v-if="actions.length > 0">
    <IntercomButton
      v-for="action in actions"
      :key="action.key"
      :variant="action.variant"
      size="sm"
      @click="$emit(action.key)"
    >
      {{ action.label }}
    </IntercomButton>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { IntercomButton } from '@shared/components/intercom'
import { userActions } from '../config/statusConfig.js'

const { t } = useI18n()

const props = defineProps({
  status: { type: String, required: true },
})

defineEmits(['cancel', 'respond', 'dispute'])

const actionDefs = {
  cancel: { label: () => t('case.cancelCase'), variant: 'ghost' },
  respond: { label: () => t('case.respondToInfo'), variant: 'primary' },
  dispute: { label: () => t('case.disputeCase'), variant: 'warning' },
}

const actions = computed(() => {
  const allowed = userActions[props.status] || []
  return allowed.map((key) => ({
    key,
    label: actionDefs[key]?.label() || key,
    variant: actionDefs[key]?.variant || 'secondary',
  }))
})
</script>

<style scoped>
.case-actions {
  display: flex;
  gap: var(--space-2);
}
</style>
